import SearchBarDateRangeInput from '@components/ui/search/SearchBarInput/SearchBarDateInput/SearchBarRangeDatePickerInput/SearchBarDateRangePickerInput';
import SearchBarSingleDatePickerInput from '@components/ui/search/SearchBarInput/SearchBarDateInput/SearchBarSingleDatePickerInput/SearchBarSingleDatePickerInput';
import { DayPickerRangeControllerProps } from '@components/DatePicker/DateRangePicker/DateRangePicker';
import { LocationAnimationErrorBox } from '@components/views/components/listing/ListingStyle';
import { SearchBarInputError } from '@components/views/flight/types';
import { DayPickerSingleDateControllerProps } from '@components/DatePicker/SingleDatePicker/SingleDatePicker';

import { isFlightReturnDateOutsideRange } from './utils';

const SearchBarRangeDatePicker = ({
  startDate,
  endDate,
  onDatesChange,
  minimumNights,
  error,
  isBookerSearch,
  setButtonDisable,
  flightFocusedInput,
  setFlightFocusedInput,
  isHoliday,
}: Pick<
  DayPickerRangeControllerProps,
  'startDate' | 'endDate' | 'onDatesChange' | 'minimumNights'
> & {
  error: SearchBarInputError | boolean;
  isBookerSearch?: boolean;
  setButtonDisable?: React.Dispatch<React.SetStateAction<boolean>>;
  flightFocusedInput?: 'startDate' | 'endDate' | null;
  setFlightFocusedInput?: (value: 'startDate' | 'endDate' | null) => void;
  isHoliday?: boolean;
}) => (
  <LocationAnimationErrorBox borderRadius='8px' hasError={!!error}>
    <SearchBarDateRangeInput
      setButtonDisable={setButtonDisable}
      dateProps={{
        minimumNights,
        startDate,
        endDate,
        onDatesChange,
        isOutsideRange: (day) => isFlightReturnDateOutsideRange(day, startDate),
      }}
      isHoliday={isHoliday}
      placeholder='Gidiş - Dönüş Tarihleri'
      label='Gidiş-Dönüş Tarihiniz?'
      isFlight={true}
      isBookerSearch={isBookerSearch}
      flightFocusedInput={flightFocusedInput}
      setFlightFocusedInput={setFlightFocusedInput}
    />
  </LocationAnimationErrorBox>
);

const SearchBarSingleDatePicker = ({
  date,
  onDateChange,
  error,
  isBookerSearch,
  setButtonDisable,
}: Pick<DayPickerSingleDateControllerProps, 'date' | 'onDateChange'> & {
  error: SearchBarInputError | boolean;
  isBookerSearch?: boolean;
  setButtonDisable?: React.Dispatch<React.SetStateAction<boolean>>;
}) => (
  <SearchBarSingleDatePickerInput
    setButtonDisable={setButtonDisable}
    isBookerSearch={isBookerSearch}
    placeholder='Gidiş Tarihi'
    label='Gidiş Tarihiniz?'
    error={Boolean(error)}
    dateProps={{
      date,
      onDateChange,
    }}
    borderRadius='8px'
  />
);

export { SearchBarRangeDatePicker, SearchBarSingleDatePicker };
